import { combineReducers } from "redux";
import UserReducer from "./UserReducer";
import GamesDataReducer from "./GamesDataReducer";
import PropertyReducer from "./PropertyReducer";
import SelectPropertyReducer from "./SelectPropertyReducer";
import VendorTypesReducer from "./VendorTypesReducer";
import PartnersReducer from "./PartnersReducer";
import SelectedPartnerReducer from "./SelectedPartnerReducer";
import PendingTasksReducer from "./PendingTasksReducer";
import LocationsReducer from "./LocationsReducer";
import SelectLocationReducer from "./SelectLocationReducer";
import SelectedStaffClientReducer from "./SelectedStaffClientReducer";
import StaffClientReducer from "./StaffClientReducer";
import BankAccountsReducer from "./BankAccountsReducer";
import IsStampRequiredReducer from "./IsStampRequiredReducer";
import IsPayoutEnabledReducer from "./IsPayoutEnabledReducer";
import StaffListReducer from "./StaffListReducer";

const rootReducer = combineReducers({
  UserReducer,
  GamesDataReducer,
  PropertyReducer,
  PartnersReducer,
  SelectPropertyReducer,
  SelectedPartnerReducer,
  VendorTypesReducer,
  PendingTasksReducer,
  LocationsReducer,
  SelectLocationReducer,
  SelectedStaffClientReducer,
  StaffClientReducer,
  BankAccountsReducer,
  IsStampRequiredReducer,
  IsPayoutEnabledReducer,
  StaffListReducer
});

export default rootReducer;
